<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iwieOq/tc-custom/9781504088176.jpg?1728327144322" alt="This image is the cover for the book Buried for Pleasure, The Gervase Fen Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Buried for Pleasure, The Gervase Fen Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A sleuthing Oxford professor hunts a village blackmailer, in a novel by an author who “combines a flawless plot, witty dialogue, and a touch of hilarity” (<i>The New York Times</i>).</b><br/><br/>In the sleepy English village of Sanford Angelorum, Oxford professor and amateur detective Gervase Fen is taking a break from his books to run for Parliament. At first glance, the village he's come to canvass appears perfectly peaceful, but Fen soon discovers that appearances can be deceiving: someone in the village has discovered a dark secret and is using it for blackmail. Anyone who comes close to uncovering the blackmailer's identity is swiftly dispatched.<br/><br/>As the joys of politics wear off, Fen sets his mind to the mystery—but finds himself caught up in a tangled tale of eccentric psychiatrists, escaped lunatics, beautiful women, and lost heirs . . .<br/><br/>“His books are full of high spirits and excellent jokes, with constant literary allusions . . . But at times the mood turns darker, and Crispin is capable of passages of both genuine suspense and ingenious deduction.” —<i>The Daily Telegraph</i><br/><br/>“One of the most literate mystery writers of the twentieth century.” —<i>Boston Globe</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edmund Crispin
      </h2>
      
      <p class="authorDescription body article">Bruce Montgomery, better known by his pen name Edmund Crispin, was an English crime writer and composer. He attended St. John’s College at Oxford and later became a teacher at Shrewsbury School. While at Shrewsbury, he wrote nine novels and multiple short stories, and also became a widely respected reviewer for the <I>Sunday Times</I>. Montgomery was also very musically inclined, composing scores for more than thirty films, including the <I>Carry On</I> series. In the last year of his life, he published his final novel, <I>The Glimpses of the Moon</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ipso Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f5cbd4c6